var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCommentCount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.88403 12.375H14.5614C15.2863 12.375 15.8739 11.7874 15.8739 11.0625V4.6875C15.8739 3.96263 15.2863 3.375 14.5614 3.375H4.4364C3.71153 3.375 3.1239 3.96263 3.1239 4.6875V11.0625C3.1239 11.7874 3.71153 12.375 4.4364 12.375H6.12299L6.12315 12.9373L6.1238 15.188L9.88403 12.375Z",
    fill: "#12243E",
    fillOpacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4364 13.5C3.0902 13.5 1.9989 12.4087 1.9989 11.0625V4.6875C1.9989 3.3413 3.0902 2.25 4.4364 2.25H14.5614C15.9076 2.25 16.9989 3.3413 16.9989 4.6875V11.0625C16.9989 12.4087 15.9076 13.5 14.5614 13.5H10.2583L6.49791 16.313C6.08329 16.6231 5.49578 16.5384 5.18566 16.1238C5.06442 15.9616 4.9989 15.7647 4.9989 15.5624L4.99831 13.5H4.4364ZM9.88403 12.375H14.5614C15.2863 12.375 15.8739 11.7874 15.8739 11.0625V4.6875C15.8739 3.96263 15.2863 3.375 14.5614 3.375H4.4364C3.71153 3.375 3.1239 3.96263 3.1239 4.6875V11.0625C3.1239 11.7874 3.71153 12.375 4.4364 12.375H6.12299L6.12315 12.9373L6.1238 15.188L9.88403 12.375Z",
    fill: "#12243E",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentCount);
export default __webpack_public_path__ + "static/media/comment-count.9c611bd1.svg";
export { ForwardRef as ReactComponent };